    <div id="loadCardsPage">

      <dx-responsive-box singleColumnScreen="sm" [(screenByWidth)]="getSizeQualifier">
        <dxi-row [ratio]="1"></dxi-row>
        <dxi-row [ratio]="1"></dxi-row>
        <dxi-row [ratio]="1"></dxi-row>
    
        <dxi-col [ratio]="1"></dxi-col>
        <dxi-col [ratio]="1"></dxi-col>
        <dxi-col [ratio]="1"></dxi-col>

        <dxi-item>
          <dxi-location
            [row]="0"
            [col]="0"
            [colspan]="3"
            screen="lg"
          ></dxi-location>
          <dxi-location
            [row]="0"
            [col]="0"
            [colspan]="1"
            screen="sm"
          ></dxi-location>
          <div *dxTemplate class="header item">
             <!-- <form id="CardsForm" #form method="post" action="" enctype="multipart/form-data" [style]="{'margin-left':'0px'}"> -->
                
                  <!-- 
                  
                    Do not remove uploadUrl attribute, 
                    this is to ensure that we control when the file gets uploaded 
                    without using devExtreme buttons which will show up on the ui 
                  -->
                  
                  

                  <div #stockcards_dropzone_external id="stockCards-UploadArea" class="flex-box uploadArea" [ngClass]="isstockCardsDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']">
                    


                    <div class="upload-card-container" *ngIf="importedfile">
                   
                      <!-- Dx Card -->
                      <div class="dx-card upload-card">
  
                        <!-- First Row: File Name with Ellipsis and File Size -->
                        <div class="card-row">
                          <span class="close-icon"> 
                            <div class="close-icon" (click)="clearFile($event)"><i class="dx-icon dx-icon-close"></i>
                          </div>
                        </span>
                          <span class="file-name" title="{{ importedfile.name }}">{{ importedfile.name }}</span>
                          <span class="file-size">{{ (importedfile.size / 1024).toFixed(2) }} KB</span>
                        </div>
                    
                        <!-- Second Row: Status -->
                        <div class="card-row status">
                          <span [ngClass]="{'upload-failed': uploadFailed, 'upload-ready': !uploadFailed}">
                            {{ uploadFailed ? 'Upload Failed' : 'Upload Ready' }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div id="stockCards-dropzone-text" class="flex-box uploadArea" *ngIf="stockCardstextVisible">
                      <span>Upload Import File</span>
                    </div>
                  
                   </div>
                   <dx-file-uploader
                      #stockCards_fileUploader
                      id="stockCards-fileSelector"
                      [visible]="false"
                      [uploadCustomData]="{ KeyCloakUserId:UserKeycloakGuidId, MerchantId : 0, DocumentType: 'BatchCardImport' }"
                      uploadMode="instantly"
                      uploadUrl="{{this.dummyFileUploadUrl}}"
                      accept="text/plain,.txt"
                      (onDropZoneEnter)="onDropZoneEnter($event)"
                      (onDropZoneLeave)="onDropZoneLeave($event)"
                      (onUploaded)="onUploaded($event)"
                      (onProgress)="onProgress($event)"
                      (onUploadStarted)="onUploadStarted($event)"
                      (onUploadError)="onUploadError($event)"
                      (onUploadAborted)="onUploadAborted($event)"
                      (onValueChanged)="showOrHideInvalidFileExtensionError($event)">
                    </dx-file-uploader>

                   <div class="container progress-bar-container">

                     <dx-progress-bar #stockCards_uploadProgress
                                      [min]="0"
                                      [max]="100"
                                      width="100%"
                                      [showStatus]="true"
                                      [statusFormat]="statusFormat"
                                      [visible]="stockCardsprogressVisible"
                                      [value]="stockCardsprogressValue">

                     </dx-progress-bar>
                   </div>
                   

                    <div class="content item" *ngIf="CardsImported > 0 && CardsImported == NumberOfCardsStatedInFile">
                      <div class="col-md-12" >Number of Cards</div>
                      <div class="col-md-12" >{{CardsImported}}</div>
                      
                    </div>
                    <div class="content item" *ngIf="CardsImported > 0 && CardsImported != NumberOfCardsStatedInFile">
                      <div class="col-md-12 error-row">
                        <div>
                          Calculated cards does not match the expected card count. Please review and retry.
                        </div>
                        

                      </div>
                      <div class="col-md-12"> Cards Extracted: <span class="CardsFound">{{CardsImported}}</span></div>
                      <div class="col-md-12"> Expected Number of Cards: <span class="NUMBEROFCARDSINORDER">{{NumberOfCardsStatedInFile}}</span> </div>
                    </div>

                    <div class="content item error-row" *ngIf="invalidFileTypeUploaded">
                      <div class="col-md-12"> File type is not allowed. </div>
                    </div>
                      
                    <div class="content item invisible-placeholder" *ngIf="CardsImported == 0">
                      <div class="col-md-12">Default</div>
                      <div class="col-md-12">{{CardsImported}}</div>
                    </div>
                    
            <!-- </form>  -->
          </div>
        </dxi-item>

        <dxi-item>
          <dxi-location
            [row]="1"
            [col]="0"
            [colspan]="2"
            screen="lg"
          ></dxi-location>
          <dxi-location
            [row]="1"
            [col]="0"
            [colspan]="1"
            screen="sm"
          ></dxi-location>
          <div *dxTemplate class="content item">
            
          </div>
        </dxi-item>

        <dxi-item>
          <dxi-location [row]="2" [col]="0" screen="lg"></dxi-location>
          <dxi-location
            [row]="2"
            [col]="0"
            screen="sm"
          ></dxi-location>
          
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="2" [col]="1" [colspan]="2" screen="lg"></dxi-location>
            <dxi-location
            [row]="2"
            [col]="1"
            [colspan]="1"
            screen="sm"
          ></dxi-location>
            <div *dxTemplate class="right-side-bar footer item">
              <dx-button type="default" text="Submit" (onClick)="uploadFileToBackend($event)" [disabled]="!(this.cardsList.length > 0 && this.CardsImported == this.NumberOfCardsStatedInFile && !this.invalidFileTypeUploaded)" ></dx-button>
              
            </div>
        </dxi-item>

      </dx-responsive-box>
    </div>
